import { FC, useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useTranslation } from '../i18n';
import { AppContext } from '../window';
import { NotificationContext } from '../context/NotificationContext';

interface MemberRouteProps {
  children: React.ReactNode;
}

const MemberRoute: FC<MemberRouteProps> = ({ children }) => {
  const { t } = useTranslation();
  const { user } = useContext(AppContext);
  const { addNotification } = useContext(NotificationContext);
  const location = useLocation();
  
  useEffect(() => {
    if (!user && location.pathname !== '/') {
      addNotification({
        level: 'warning',
        message: t('general.please_login_to_access')
      });
    }
  }, [user, location.pathname]); // Remove addNotification from deps to prevent re-runs
  
  if (!user) {
    // Redirect to home page with the intended destination stored
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  return <>{children}</>;
};

export default MemberRoute;